import { type ComponentType } from 'react';

import {
	ButtonStyle,
	CommonLayout,
	CornerStyle,
	ITEM_FIELDS as FRAME_FIELDS,
	Height,
	type HubDefaultParameters,
	type HubExtensionsWrapperProps,
	type OnFailed,
	type OnSucceeded,
	type ProductDependenciesProviderProps,
} from '@atlassian/company-hub-common';

export type CarouselParameters = {
	cards: Frame[];
	cornerRadius?: number;
	cornerStyle?: CornerStyle;
	extensionTitle: string;
	isAutoplayEnabled?: boolean;
	navigationStyle?: NavigationStyle;
	version: string;
};

export type Frame = {
	[FRAME_FIELDS.BACKGROUND_COLOR]?: string;
	[FRAME_FIELDS.BUTTON_STYLE]?: ButtonStyle;
	[FRAME_FIELDS.BUTTON_TEXT]?: string;
	[FRAME_FIELDS.CARD_ID]: string;
	[FRAME_FIELDS.CONFLUENCE_PAGE_ID]?: string;
	[FRAME_FIELDS.DESCRIPTION]?: string;
	[FRAME_FIELDS.HEIGHT]?: Height;
	[FRAME_FIELDS.IMAGE_ALT_TEXT]?: string;
	[FRAME_FIELDS.IMAGE_SRC]?: string;
	[FRAME_FIELDS.IS_DESCRIPTION_USER_EDITED]?: boolean;
	[FRAME_FIELDS.IS_LINK_USER_EDITED]?: boolean;
	[FRAME_FIELDS.IS_TITLE_USER_EDITED]?: boolean;
	[FRAME_FIELDS.LAYOUT]?: CommonLayout;
	[FRAME_FIELDS.LINK]: string;
	[FRAME_FIELDS.TEXT_COLOR]?: string;
	[FRAME_FIELDS.TITLE]?: string;
};

export enum NavigationStyle {
	PROGRESS_CIRCLES = 'progress-circles',
	THUMBNAILS = 'thumbnails',
}

export { CornerStyle, CommonLayout, Height, ButtonStyle };

export enum FrameSizes {
	NAVIGATION_THUMBNAIL = 'navigationThumbnail',
	NAVIGATION_THUMBNAIL_V2 = 'navigationThumbnailV2',
}

export { FRAME_FIELDS };

type FrameDimensions = {
	height: number;
	maxWidth: number;
	minWidth: number;
};

type FramesDimensions = {
	[key in FrameSizes]: FrameDimensions;
};

export const framesDimensions: FramesDimensions = {
	[FrameSizes.NAVIGATION_THUMBNAIL_V2]: {
		minWidth: 200,
		maxWidth: 200,
		height: 40,
	},
	[FrameSizes.NAVIGATION_THUMBNAIL]: {
		minWidth: 244,
		maxWidth: 250,
		height: 72,
	},
};

export type CommonFrameProps = {
	contentId: string;
	isEmpty?: boolean;
	onFailed: OnFailed;
	onSucceeded: OnSucceeded;
	wrapperHeight?: number;
} & Frame;

export type ResolvedLinkDataObject = {
	data: {
		image?: {
			url?: string;
		};
		name?: string;
		summary?: string;
	};
	meta: {
		objectId?: string;
		resourceType?: string;
	};
};

export type CarouselExtensionProps = HubExtensionsWrapperProps<CarouselParameters> & {
	defaultParameters?: HubDefaultParameters;
	propsProvider: ComponentType<ProductDependenciesProviderProps>;
};
